var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73549 1.18226C9.80374 1.11281 9.88519 1.05763 9.97508 1.01996C10.065 0.982293 10.1615 0.962891 10.259 0.962891C10.3565 0.962891 10.453 0.982293 10.5429 1.01996C10.6328 1.05763 10.7142 1.11281 10.7825 1.18226C11.0685 1.47052 11.0725 1.93633 10.7925 2.22958L4.87949 9.20173C4.81236 9.27526 4.73089 9.33436 4.64007 9.37541C4.54925 9.41645 4.45099 9.43859 4.3513 9.44046C4.25161 9.44232 4.15258 9.42388 4.06028 9.38627C3.96798 9.34865 3.88435 9.29264 3.81449 9.22168L0.216492 5.58499C0.077729 5.44384 0 5.25403 0 5.05634C0 4.85865 0.077729 4.66885 0.216492 4.5277C0.284738 4.45824 0.36619 4.40306 0.45608 4.36539C0.54597 4.32773 0.642491 4.30832 0.739992 4.30832C0.837493 4.30832 0.934014 4.32773 1.0239 4.36539C1.11379 4.40306 1.19525 4.45824 1.26349 4.5277L4.31549 7.6128L9.71549 1.20421C9.72171 1.1965 9.72839 1.18917 9.73549 1.18226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedTick);
export default __webpack_public_path__ + "static/media/checked-tick.55a8c23f9a70ab09963ca8f2151e1cb7.svg";
export { ForwardRef as ReactComponent };